import React from 'react';
import { Box, Icon } from '@hover/blueprint';
import { iArrowUp } from '@hover/icons';
import { useBackToTop } from '../../../hooks';

const BackToTopButton: React.FC = () => {
  const { showButton, backToTop } = useBackToTop();

  return showButton ? (
    <Box
      aria-label="back-to-top-button"
      d={{ base: 'flex', tablet: 'none' }}
      bg="neutral.0"
      position="fixed"
      bottom="112px"
      right="32px"
      zIndex={100}
      w="36px"
      h="36px"
      borderRadius="50%"
      shadow="distance300"
      alignItems="center"
      justifyContent="center"
      onClick={backToTop}
      as="button"
      _focus={{ backgroundColor: 'primary.100' }}
    >
      <Icon size="large" icon={iArrowUp} color="brandNavy.500" />
    </Box>
  ) : (
    <></>
  );
};

export default BackToTopButton;
